<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader class="d-flex align-items-center flex-wrap justify-content-between pb-0 header-with-nav">
                    <strong>Заказы</strong>
                    <OrdersTabLinks class="mb-0" />
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary" />
                    </div>
                    <template v-else>
                        <CCard v-if="isAuthorized" class="p-1">
                            <CRow>
                                <CSwitch color="dark" shape="pill" variant="opposite" :checked.sync="showFilters" class="ml-4" />
                                <span class="ml-2">Экспорт</span>
                            </CRow>
                            <CRow v-if="showFilters" class="mb-1">
                                <CCol cols="12" md="2"> Дата начала: </CCol>
                                <CCol cols="12" md="4">
                                    <DatePicker v-model="datepicker.dateFrom" :language="datepicker.lang" :format="datepicker.format" input-class="custom-datepicker" placeholder="Выберите дату..." />
                                </CCol>
                                <CCol cols="12" md="2"> Дата окончания: </CCol>
                                <CCol cols="12" md="4">
                                    <DatePicker v-model="datepicker.dateTo" :language="datepicker.lang" :format="datepicker.format" input-class="custom-datepicker" placeholder="Выберите дату..." />
                                </CCol>
                            </CRow>
                            <CRow v-if="showFilters" class="mt-2">
                                <CCol md="8" class="pl-1">
                                    <CSelect :horizontal="true" label="Фильтровать по:" class="mb-xl-0 ml-sm-2 pl-0" :value.sync="exportFilter" :options="exportFilterOptions" />
                                </CCol>
                                <CCol md="4" class="pl-1 flex align-items-center">
                                    <span class="mr-1">Включить Отмененные/Инциденты</span>
                                    <CSwitch color="dark" shape="pill" variant="opposite" :checked.sync="exportCanceled" />
                                </CCol>
                            </CRow>
                            <CRow v-if="showFilters" class="mt-2">
                                <CCol md="8" class="pl-1">
                                    <CSelect :horizontal="true" label="Тип даты:" class="mb-xl-0 ml-sm-2 pl-0" :value.sync="exportDateType" :options="exportDateTypeOptions" />
                                </CCol>
                            </CRow>
                            <CRow v-if="showFilters" class="mt-2">
                                <CCol md="4">
                                    <CButton color="primary" @click="doExport">Запустить экспорт</CButton>
                                </CCol>
                                <CCol cols="3">
                                    {{ exportMessage }}
                                    <CLink to="/export">{{ exportFile }}</CLink>
                                </CCol>
                            </CRow>
                        </CCard>
                        <OrdersTable :list.sync="items" :total.sync="totalOrders" use-search use-filter use-sorter completed @set-sorter="setSorter" @set-filter="setFilter" @set-search="search" />
                        <CPagination :active-page.sync="activePage" class="mt-4" :pages="total" align="center" />
                    </template>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import OrdersTable from '@/components/orders/OrdersTable';
import OrdersTabLinks from '@/components/orders/OrdersTabLinks';
import DatePicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import { ORDER_STATUS } from '../../utils/order';
import { isAuthorized } from '../../utils/role';

const { ITEMS_PER_PAGE } = require('../../utils/views');

export default {
    name: 'Orders',

    components: {
        OrdersTable,
        OrdersTabLinks,
        DatePicker,
    },

    data() {
        return {
            isAuthorized: false,
            loading: true,
            items: [],
            total: 1,
            timerId: null,
            datepicker: {
                lang: ru,
                format: 'dd.MM.yyyy',
                dateFrom: null,
                dateTo: null,
            },
            showFilters: false,
            exportMessage: '',
            exportFile: '',
            searchFilters: {},
            sorter: '',
            filter: '',
            exportFilter: ORDER_STATUS.DONE,
            exportFilterOptions: [
                { value: ORDER_STATUS.DONE, label: 'По дате завершения' },
                { value: ORDER_STATUS.PAID, label: 'По дате оплаты' },
            ],
            exportCanceled: false,
            totalOrders: null,
            exportDateType: 'creation',
            exportDateTypeOptions: [
                { value: 'creation', label: 'По дате создания заказа' },
                { value: 'delivery', label: 'По дате доставки заказа' },
            ],
            state: {
                request: null,
            },
        };
    },

    computed: {
        activePage: {
            get() {
                return parseInt(this.$route.query.page) || 1;
            },
            async set(v) {
                const query = { page: v };
                this.$router.push({ query });
            },
        },
    },

    watch: {
        activePage: 'loadData',
        searchFilters: 'loadData',
        sorter: 'loadData',
        filter: 'loadData',
    },

    async mounted() {
        // If business administrator - go to particular page
        const settings = JSON.parse(localStorage.getItem('settings'));
        if (settings.is_business_admin) {
            if (settings.restaurants && settings.restaurants.length) {
                this.$router.push('/orders/orders-rd');
            } else if (settings.florists && settings.florists.length) {
                this.$router.push('/orders/orders-fd');
            } else if (settings.laundries && settings.laundries.length) {
                this.$router.push('/orders/orders-ld');
            } else if (settings.grocers && settings.grocers.length) {
                this.$router.push('/orders/orders-gd');
            } else if (settings.pharmacies && settings.pharmacies.length) {
                this.$router.push('/orders/orders-pd');
            } else {
                return;
            }
        }

        this.isAuthorized = isAuthorized(['admin', 'super_admin']);

        await this.loadData();
        this.loading = false;
        this.timerId = setInterval(this.loadData, 10000);
    },

    beforeDestroy() {
        clearInterval(this.timerId);
    },

    methods: {
        async loadData() {
            if (this.state.request) {
                this.state.request.abort();
            }
            let filter = null;
            try {
                filter = JSON.parse(this.filter);
            } catch (e) {
                // console.log(e);
            }
            const params = {
                page: this.activePage,
                pageSize: ITEMS_PER_PAGE,
                completed: 1,
                search: this.searchFilters,
                sorter: this.sorter,
                filter,
            };
            this.state.request = new AbortController();

            await Vue.axios
                .get('/orders', { params, signal: this.state.request.signal })
                .then((resp) => {
                    this.items = resp.data.results;
                    this.total = Math.ceil(resp.data.total / ITEMS_PER_PAGE);
                    this.totalOrders = resp.data.total;
                })
                .catch((err) => {
                    this.$root.$emit('showError', 'Ошибка загрузки заказов. ' + err);
                });

            this.state.request = null;
        },
        search(val) {
            this.searchFilters = val;
        },
        pageChange(val) {
            this.$router.push({ query: { page: val } });
        },
        doExport() {
            if (!this.datepicker.dateFrom || !this.datepicker.dateTo) {
                this.$root.$emit('showError', 'Укажите даты начала и окончания для экспорта');
                return;
            }
            const filters = {
                status: this.exportFilter,
                canceled: this.exportCanceled,
                dateType: this.exportDateType,
            };
            const dateFrom = moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD');
            const dateTo = moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD');
            this.axios.get(`/export/orders?dateFrom=${dateFrom}&dateTo=${dateTo}&filter=${JSON.stringify(filters)}`).then((res) => {
                this.exportMessage = res.data.message;
                this.exportFile = res.data.filename;
            });
        },
        setSorter(sorter) {
            this.sorter = sorter;
        },
        setFilter(filter) {
            const debounceFunc = _.debounce(() => {
                const filterObj = {
                    concierge_id: (filter && filter.concierge_id ? filter.concierge_id : []).map((i) => i.value),
                    courier_id: (filter && filter.courier_id ? filter.courier_id : []).map((i) => i.value),
                    status: (filter && filter.status ? filter.status : []).map((i) => i.value),
                    tower: (filter && filter.tower ? filter.tower : []).map((i) => i.value),
                    type: (filter && filter.type ? filter.type : []).map((i) => i.value),
                    have_comments: filter?.have_comments?.length ? [filter?.have_comments[0].value] : ['all'],
                    have_rating: filter?.have_rating?.length ? [filter?.have_rating[0].value] : ['all'],
                    have_tips: filter?.have_tips?.length ? [filter?.have_tips[0].value] : ['all'],
                    from: filter?.from ? filter?.from : null,
                    to: filter?.to ? filter?.to : null,
                    client_last_name: filter?.client_last_name ? filter?.client_last_name : null,
                    client_first_name: filter?.client_first_name ? filter?.client_first_name : null,
                    client_phone: filter?.client_phone ? filter?.client_phone : null,
                };
                this.filter = JSON.stringify(filterObj);
            }, 2000);
            debounceFunc();
        },
    },
};
</script>

<style>
input.custom-datepicker {
    border: 1px solid;
    border-color: #d8dbe0;
    width: 100%;
}
.header-with-nav ul.nav.nav-tabs {
    border-bottom: 0;
}
</style>
